import { useContext, useEffect, useMemo, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import operationService from '../services/operationService';

const getProfileCode = (user) => {
  if (!user) return null;
  const code = (
    user.profileCode
    || user.ProfileCode
    || user.vUserTypeCode
    || user.role
    || user.Role
    || ''
  ).toString().trim();
  if (!code) return null;
  if (code === 'Admin') return 'ADMIN';
  return code.toUpperCase();
};

export function useAllowedReports() {
  const { user } = useContext(AuthContext);
  const profileCode = useMemo(() => getProfileCode(user), [user]);
  const [allowedPaths, setAllowedPaths] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!profileCode) {
      setAllowedPaths(new Set());
      setLoading(false);
      setError(null);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    operationService
      .getReportsForProfile(profileCode)
      .then((items) => {
        if (cancelled) return;
        const paths = (items || [])
          .map((item) => (item.operationPath || item.OperationPath || '').trim())
          .filter(Boolean);
        setAllowedPaths(new Set(paths));
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err?.response?.data?.message || err.message || 'Failed to load reports');
          setAllowedPaths(new Set());
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [profileCode]);

  const isPathAllowed = (path) => {
    if (!allowedPaths) return false;
    if (allowedPaths.size === 0) return false;
    return allowedPaths.has(path);
  };

  return { allowedPaths, loading, error, isPathAllowed, profileCode };
}

export default useAllowedReports;
